import { useEffect, useState } from "react";

function getMediaQueryMatch(query) {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
}

export default function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => getMediaQueryMatch(query));

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return undefined;

        const mediaQuery = window.matchMedia(query);
        const syncMatches = () => setMatches(mediaQuery.matches);

        syncMatches();

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener("change", syncMatches);
            return () => mediaQuery.removeEventListener("change", syncMatches);
        }

        mediaQuery.addListener(syncMatches);
        return () => mediaQuery.removeListener(syncMatches);
    }, [query]);

    return matches;
}
